export type ChangedField = 'net' | 'gross' | 'expenses'

export type ChangedFieldsType = {
    NET: ChangedField,
    GROSS: ChangedField,
    EXPENSES: ChangedField,
}

export const ChangedFields: ChangedFieldsType = {
    NET: 'net',
    GROSS: 'gross',
    EXPENSES: 'expenses',
}